<template>
<div>
  <div class="panel">

    <!-- linea clasificacion -->
    <div class="flex w-full flex-col lg:flex-row items-start">
      <div class="flex flex-col lg:flex-row items-start w-full lg:w-full">
        <!-- Clase de incidencia -->
        <div class="w-full lg:w-1/3 lg:mr-1">
          <l-form-select
              :form="form"
              field="class_id"
              :options="issueClassesList"
              label="issue_classification"
              :disabled="!createNew && !form.is_open"
              icon="spell-check"
              full
              optionDisplayField="name"
            />
        </div>
      </div>
    </div>

    <!--  linea tipo, disciplina, origen -->
    <div class="flex w-full flex-col lg:flex-row items-start mt-3">
      <div class="flex flex-col lg:flex-row items-start w-full lg:w-full">
        <!-- Tipo de incidencia -->
        <div class="w-full lg:w-1/3 lg:mr-1">
          <l-form-select
              :form="form"
              field="type_id"
              :options="issueTypesList"
              label="issue_type"
              :disabled="!createNew && !form.is_open"
              icon="spell-check"
              full
              optionDisplayField="name"
            />
        </div>
        <div class="w-full lg:w-1/3 lg:mr-1">
          <l-form-select
            :form="form"
            field="supply_id"
            :options="issueTypeSupply"
            :label="$t('supply')"
            :disabled="blockFields || !isSupply"
            icon="spell-check"
            full
            optionDisplayField="name"
          />
        </div>
        <div class="w-full lg:w-1/3 lg:mr-1">
          <l-form-select
            :form="form"
            :disabled="blockFields || !isTypeSupplyProvider"
            field="supply_provider_id"
            :options="issueTypeSupplyProviderList"
            label="providers"
            icon="spell-check"
            full
            optionDisplayField="name"
          />
        </div>
        <!-- Disciplina de incidencia -->
        <div class="w-full lg:w-1/3 lg:mr-1">
          <l-form-select
              :form="form"
              field="discipline_id"
              :options="issueDisciplinesList"
              label="issue_disciplines"
              :disabled=" blockFields || (!createNew && !form.is_open)"
              icon="spell-check"
              full
              optionDisplayField="name"
            />
        </div>
        <!-- Origen de incidencia -->
        <div class="w-full lg:w-1/3 lg:mr-1">
          <l-form-select
              :form="form"
              field="origin_id"
              :options="issueOriginsList"
              label="issue_origins"
              :disabled=" blockFields || (!createNew && !form.is_open)"
              icon="spell-check"
              full
              optionDisplayField="name"
            />
        </div>
      </div>
    </div>

    <div v-if="withFlow" class="flex w-full flex-col lg:flex-row items-start mt-3">
      <div class="flex flex-col lg:flex-row items-start w-full lg:w-full">
        <div class="w-full lg:w-1/3 lg:mr-1">
          <!-- select templates -->
          <l-form-select  
            :form="form"
            field="template_id"
            :options="templates"
            label="validation_flow"
            :disabled="!createNew && !form.is_open"
            icon="spell-check"
            full
            optionDisplayField="name" />

        </div>
        <div class="w-full lg:w-1/3 lg:mr-1">
          <l-form-input ref="flowDescription"
            :form="form"
            field="flow_description"
            label="validation_description"
            :disabled="!createNew && !form.is_open"
          />
        </div>
      </div>
    </div>

    <div v-if="withFlow" class="flex w-full flex-col lg:flex-row items-start mt-3">
        <entity-validationflows
        v-if="!createNew && form.is_open"
        ref="entity_validationflows"
        :entity-id="parseInt(issueId)"
        entity-type="issue"
        />
    </div>

    <!-- linea de campos personalizados y previsualizacion del codigo generado -->
    <div v-if="issuefields.length" class="panel">
      <div class="flex flex-wrap w-full items-start mt-3">
        <div class="w-full sm:w-1/2 lg:w-1/4 p-1" 
          v-for="(field, index) in issuefields" :key="'issuefield_'+index"
        >
          <b-field :label="field.name">
            <b-select
              v-if="field.values && field.values.length"
              v-model="formFields[index].code"
              placeholder="select"
              expanded
            >
              <option v-for="(option, idx) in field.values" 
                :key="'option_'+idx" :value="option.code"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>

      <!-- generated Code  mostramos el texto de form.code2 (prefijo del code2 que se persiste en backend) -->
      <div>
        <l-form-input
          :form="form"
          field="code2"
          label="code"
          :disabled="true"
        />
      </div>
    </div>

    <div v-if="assignment" class="panel mb-6">
      <h3 class="font-bold text-lg mb-4">{{ $t('linked_assignment') }}: {{ assignment.name }}</h3>
      <p v-if="assignment.issue_status">{{ $t('lock_type') }}: {{ $t(lockTypeMap[assignment.issue_status]) }}</p>
    </div>

    <div class="flex w-full flex-col lg:flex-row items-start mt-3">
      <div class="flex flex-col lg:flex-row items-start w-full lg:w-full">
        <div class="w-full lg:w-1/3 lg:mr-1">
          <l-form-input ref="issueName"
            :form="form"
            field="name"
            label="issue_name"
            :disabled="!createNew && !form.is_open"
          />
        </div>
        <div class="w-full lg:w-1/3 lg:mr-1">
          <l-form-select
            :form="form"
            field="location_id"
            :options="locationsList"
            label="select_location"
            :disabled="!createNew && !form.is_open"
            icon="map-marker-alt"
            full
            optionDisplayField="name"
          />
        </div>
        <div class="w-full lg:w-1/3 lg:mr-1">
          <span class="label">{{ $t('estimated_resolution_date') }}</span>
          <b-datepicker
            v-model="form.estimated_resolution_date"
            :placeholder="$t('estimated_resolution_date')"
            :month-names="$t('months_names')"
            :day-names="$t('days_names')"
            :first-day-of-week="parseInt($t('first_day_of_week'))"
            :disabled="(project.issue_template == 1 && ! project.can_issue_admin) ||(!createNew && !form.is_open)"
            icon-pack="fas"
          >
          </b-datepicker>
        </div>
      </div>
    </div>

    <!-- aqui van los custom fields -->
    <div class='panel' v-if="customfields.length" >
      <div class="flex w-full flex-col lg:flex-row items-start mt-3">
        <div class="flex flex-col lg:flex-row items-start w-full lg:w-full">
          <div class="w-full lg:w-1/3 lg:mr-1">
            <span class="label">{{ $t('customfields') }}</span>
          </div>
        </div>
      </div>
      <div class="flex w-full flex-col lg:flex-row items-start mt-3">
        <div class="flex flex-col lg:flex-row items-start w-full lg:w-full">
          <div class="w-full  lg:mr-1" 
            v-for="(field, index) in customfields" 
            :key="'field_'+field.id"
          >
            <!-- Select -->
            <l-form-select
              v-if="field.field_type === 0"
              :label="field.name"
              :options="field.values"
              field="value_id"
              full
              :form="formCustomfields[index]"
              :placeholder="$t('select')"
            />

            <!-- Input -->
            <l-form-input
              v-else-if="field.field_type === 1"
              :label="field.name"
              field="value_free"
              class="w-full"
              :form="formCustomfields[index]"
            />

            <!-- Datepicker -->
            <b-field
              v-else-if="field.field_type === 2"
              class="w-full"
              :label="field.name"
            >
              <b-datepicker
                v-model="formCustomfields[index].value_free"
                :placeholder="$t('select_date')"
                :disabled="blockFields || (!createNew && !form.is_open)"
                icon-pack="fas"
                :first-day-of-week="parseInt($t('first_day_of_week'))"
              />
            </b-field>

            <!-- Checkbox -->
            <b-field
              v-else-if="field.field_type === 3"
              class="w-full"
              :label="field.name"
            >
              <b-checkbox
                v-model="formCustomfields[index].value_free"
                :disabled="blockFields || (!createNew && !form.is_open)"
              >
                {{ field.name }}
              </b-checkbox>
            </b-field>
          </div>
        </div>
      </div>
    </div>

    <Transition name="slide">
    <div v-if="showMap" class="flex w-full flex-col lg:flex-row items-start mt-3">
      <!-- Mapa -->
      <div class="panel">
        <input type="hidden" name="address_id" id="address_id" value="">
        <googlemaps ref="mapRef"
          name="issue-location"
          :datamaps="userLocation"
          :draggable="true"
          @updPlace="updPlace"
          :newPlace="''"
          inputAutocomplete="address_id" />
      </div>
    </div>
    </Transition>

    <!-- Abierta / Cerrada -->
    <div class="w-full lg:w-1/5 flex items-center mt-3">
      <b-field v-if="! createNew" :label="$t('issue_opened')">
        <b-switch v-model="form.is_open" 
          type="is-success"
          :disabled="createNew"
        >
          {{ $t(form.is_open ? 'yes' : 'no') }}
        </b-switch>
      </b-field>
    </div>

    <!-- elegir plano donde señalar la incidencia -->
    <div class="flex mt-8">
        <b-field  :label="$t('mark_on_the_drawing')">
          <b-switch v-model="setOnDrawing"
            type="is-success"
          >
            {{ $t(setOnDrawing ? 'yes' : 'no') }}
          </b-switch>
        </b-field>
    </div>

    <Transition name="slide">
    <div class="flex flex-col lg:flex-row items-start w-full" v-if="setOnDrawing" key="drawing_list">

        {{ $t('select_a_drawing_for_issue') }}: <br>
        <div v-for="(drawing) in drawings" :key="drawing.id" v-on:click="loadDrawing(drawing)" class="text-blue text-sm rounded-xl inline-block mb-2 py-0.5 px-2 border-2 border-blue bg-blue-200 mr-1 cursor-pointer">
          {{ drawing.name }}
        </div>
        <div v-if="drawings.length==0" class="text-red">{{ $t('no_drawings_linked') }}</div>
    </div>
    </Transition>

    <Transition name="slide">
    <div class="flex flex-col lg:flex-row items-start w-full" v-show="setOnDrawing && drawing!=null" key="drawing_canvas">

        <div class="w-full pr-2">
          {{ $t('click_drawing_to_mark_issue') }}:

          <div style="overflow:auto;">
            <div id="zoom">
              <a v-on:click="loadDrawing(drawingDocument, parseFloat(scale)-0.2)" class="ml-1 button is-light is-small">
                <b-icon pack="fa" class="float-left" size="is-small" icon="magnifying-glass-minus" ></b-icon>
              </a>
              <a v-on:click="loadDrawing(drawingDocument, parseFloat(scale)+0.2)" class="ml-1 button is-light is-small">
                <b-icon pack="fa" class="float-left" size="is-small" icon="magnifying-glass-plus"></b-icon>
              </a>
              <a v-on:click="resetMarkers" class="ml-1 button is-light is-small" v-if="markerIsSet">
                Reset &nbsp;&nbsp;<b-icon pack="fa" class="float-left" size="is-small" icon="undo-alt"></b-icon>
              </a>
            </div>

            <canvas id="canvas" width="595" height="720" @click="setMarker" style="width: auto;border: 1px solid gray; box-shadow: 2px 2px 4px gray;"></canvas>
          </div>
        </div>

    </div>
    </Transition>

    <!-- Elegir pictograma  -->

    <div class="flex mt-8">
        <b-field :label="$t('mark_on_the_pictogram')">
          <b-switch v-model="setOnPictogram"
            type="is-success"
          >
            {{ $t(setOnPictogram ? 'yes' : 'no') }}
          </b-switch>
        </b-field>
    </div>

    <Transition name="slide">
      <div v-if="setOnPictogram">
          <KonvaViewerPictogram ref="refViewerPictogram"
            :canActionsPictogram="canActionsPictogram"
            :pictogram="pictogram"
            :work-layer="workLayer"
            :type-register="typeRegister"
          > </KonvaViewerPictogram>
      </div>
    </Transition>



    <!-- Descripción -->
    <div class="flex flex-col lg:flex-row w-full mt-8">
      <div class="w-full lg:w-4/5 lg:pr-2">
        <span class="label">{{ $t('issue_description') }}</span>
        <quill-editor v-model="form.description" :options="editorOption"></quill-editor>
      </div>
      <!-- Fechas -->
      <div class="w-full lg:w-1/5">
        <label class="font-bold" for="start-date-picker">{{ $t('issue_date') }}</label>
        <b-datepicker
          id="start-date-picker"
          v-model="startDate"
          icon-pack="fas"
          :disabled="!(project.can_admin || project.can_issue)"
          @input="updateDate"
        />
        <!-- <l-form-input v-if="! form.is_open"
          :form="form"
          field="end_date"
          label="closed_date"
        /> -->
        <label class="font-bold" for="closed-date-picker">{{ $t('closed_date') }}</label>
        <b-datepicker
          id="closed-date-picker"
          v-model="closedDate"
          icon-pack="fas"
          :disabled="! (project.can_admin)"
          @input="updateCloseDate"
        />
      </div>
    </div>
    <div class="flex flex-col lg:flex-row w-full mt-8">
      <div class="w-full lg:w-4/5 lg:pr-2" v-if="!blockFields">
        <span class="label">{{ $t('issue_steps_to_implement') }}</span>
        <quill-editor
          :disabled="blockFields" 
          v-model="form.steps_to_implement"
          placeholder="steps_to_implement"
          :options="editorOption"></quill-editor>
      </div>
    </div>
    <div class="flex flex-col lg:flex-row w-full mt-8">
      <div class="w-full lg:w-4/5 lg:pr-2" v-if="!project.issue_template || (!blockFields && project.can_issue_admin)">
        <span class="label">{{ $t('issue_steps_implemented') }}</span>
        <quill-editor :disabled="blockFields" v-model="form.steps_implemented" :options="editorOption"></quill-editor>
      </div>
    </div>
    <div class="flex w-full flex-col lg:flex-row mt-4">
      <!-- ETIQUETAS -->
      <div class="w-full lg:w-4/5 items-center lg:pr-2">
        <span class="label">{{ $t('issue_tags') }}</span>
        <model-tags
                :model-id="parseInt(issueId)"
                model-type="issue"
                :allow-edit="false"
                :add-from-list="true"
                :parent-model-id="this.project.id"
                parent-model-type="project"
                ref="model_tags"
        />
      </div>

    </div>

    <!-- Documentos: selector inline para creación -->
    <div v-if="createNew" class="panel mt-8">
      <div class="text-lg font-thin uppercase text-blue-light mb-4">{{ $t('documents') }}</div>
      <b-upload v-model="pendingFiles" multiple drag-drop class="w-full">
        <div class="flex justify-center w-full">
          <div class="p-6 text-center text-grey">
            <p class="m-2">
              <b-icon pack="fas" icon="upload" size="is-large" />
            </p>
            <p>{{ $t("drop_files") }}</p>
          </div>
        </div>
      </b-upload>
      <div v-if="pendingFiles.length" class="mt-3">
        <span
          v-for="(file, index) in pendingFiles"
          :key="index"
          class="inline-flex items-center px-2 py-1 mb-1 mr-1 text-xs rounded text-grey-lightest bg-blue whitespace-nowrap"
        >
          {{ file.name }}
          <button
            type="button"
            @click="pendingFiles.splice(index, 1)"
            class="flex items-center ml-2 text-white rounded-full bg-blue-dark"
            style="padding: 0.1rem"
          >
            <b-icon pack="fas" icon="times" size="is-small" />
          </button>
        </span>
      </div>
      <div v-if="isUploadingFiles" class="mt-3">
        <progress-bar
          :step="uploadPercentage"
          color="green"
          backgroundColor="grey-lightest"
          size="large"
          class="w-full"
        />
        <p class="text-sm text-grey mt-1">{{ $t('uploading_files') }}...</p>
      </div>
    </div>

    <div class="flex items-start w-full flex-col sm:flex-row mt-8">
      <!-- Responsable -->
      <userlist ref="manager"
        title="activity_manager"
        icon="bullhorn"
        :api-url="apiUrl"
        :users-permission-type="[]"
        :disabled="project.issue_template == 1 && !project.can_issue_admin"
        :only-one-user="true"
        :can-replace="true"
        :is-issue="true"
        :activity-id="parseInt(activityId)"
        class="w-full sm:w-1/2 sm:mr-3"
        roleName="activity_admin" />

      <!-- Creador -->
      <userlist ref="creator"
        title="issue_creator"
        icon="user-secret"
        :api-url="apiUrl"
        :users-permission-type="[]"
        :disabled="true"
        class="w-full sm:w-1/2 sm:ml-3" />
    </div>

    <!-- Participantes / Colaboradores -->
    <div class="flex w-full flex-col sm:flex-row items-start mt-8">
      <userlist ref="participants"
        title="users_participants"
        icon="users"
        :api-url="apiUrl"
        :parent-entity-id="createNew ? null : parseInt(issueId)"
        :users-permission-type="['participate']"
        :allow-create-users="false"
        :local-mode="createNew"
        :disabled="project.issue_template == 1 ? !project.can_issue_admin : !createNew && !form.is_open"
        :is-advanced-issue="project.issue_template"
        class="w-full sm:w-1/2 sm:mr-3"
        :withEmail="true"
        roleName="participant" />
      <userlist ref="collaborators"
        title="users_collaborators"
        icon="address-book"
        :api-url="apiUrl"
        :parent-entity-id="createNew ? null : parseInt(issueId)"
        :users-permission-type="['collaborate']"
        :allow-external-users="true"
        :allow-create-users="false"
        :local-mode="createNew"
        :only-external-users="true"
        :project-id="this.project.id"
        :disabled="project.issue_template == 1 ? !project.can_issue_admin : !createNew && !form.is_open"
        class="w-full sm:w-1/2 sm:ml-3"
        :withEmail="true"
        roleName="collaborator" />
    </div>

    <!-- responsable de incidencia / responsable de resolucion -->
    <div v-if="project.issue_template" class="flex w-full flex-col sm:flex-row items-start mt-8">
      <userlist
        ref="issue_admin"
        title="issue_managers"
        icon="exclamation-triangle"
        :api-url="apiUrl"
        :parent-entity-id="createNew ? null : parseInt(issueId)"
        :users-permission-type="['issue_admin']"
        :allow-create-users="true"
        :local-mode="createNew"
        :disabled="project.issue_template == 1 ? !project.can_issue_admin : !createNew && !form.is_open"
        class="w-full md:w-1/2 pr-3"
        roleName="issue_admin"
      />

      <!-- responsable de resolución de incidencias -->
      <userlist
        ref="issue_resolutors"
        title="issue_resolutor"
        icon="exclamation-triangle"
        :api-url="apiUrl"
        :parent-entity-id="createNew ? null : parseInt(issueId)"
        :users-permission-type="['issue_resolutor']"
        :allow-create-users="false"
        :is-advanced-issue="project.issue_template"
        :local-mode="createNew"
        :disabled="project.issue_template == 1 ? !project.can_issue_admin : !createNew && !form.is_open"
        class="w-full md:w-1/2 pr-3"
        roleName="issue_resolutor"
      />
    </div>

  </div>
  <!-- Banner de procesando -->
  <div v-if="processingData" class="w-full my-4 px-4 py-3 rounded" style="border: 1px solid rgb(250, 204, 21); border-radius: 6px; padding: 0.75em; background-color: rgb(254, 248, 195);">
    <svg class="animate-spin -ml-1 mr-3 h-5 w-5 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
    <strong>{{ processingMessage }}</strong>
  </div>

  <form @submit.prevent="sendIssueData" @keydown="form.onKeydown($event)"
    class="w-full flex items-center justify-end mb-8">

    <v-button color="grey" icon="undo-alt" @click="$router.go(-1)">{{ $t('cancel') }}</v-button>

    <v-button v-if="!processingData" type="submit" icon="thumbs-up" icon-pack="far" class="ml-4"
      >{{ $t('save') }}
    </v-button>

    <button v-if="processingData" type="button" class="inline-flex items-center px-4 py-2 ml-4 btn-blue leading-6 text-sm shadow rounded-md text-white hover:bg-orange-light transition ease-in-out duration-150 cursor-not-allowed" disabled="">
      <svg class="animate-spin mr-4 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      {{ $t('save') }}
    </button>

  </form>
</div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import Form from 'vform'
import Userlist from '~/components/UserBox/UserList'
import EventBus from '~/plugins/bus'
import ModelTags from "../../components/model-tags";
import PdfCanvas from "~/plugins/pdfCanvas";
import { format } from 'date-fns'
import Googlemaps from '~/components/GoogleMaps.vue'
import KonvaViewerPictogram from '../../components/pictograms/viewer-pixi/ViewerPageKonva.vue'
import entityValidationflows from '·/components/entity-validationflows'
import Uppy from '@uppy/core'
import AwsS3 from '@uppy/aws-s3'
import store from '~/store'

// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {quillEditor} from "vue-quill-editor";
import Quill from "~/plugins/quill";
import Mention from "quill-mention";

import VueTribute from "vue-tribute";

export default {
  middleware: 'auth',
  title: 'issue_edit_page_title',
  subtitle: 'issue_edit_page_title',
  menuOption: '2-6',

  components: {
    quillEditor,
    VueTribute,
    Userlist,
    ModelTags,
    Googlemaps,
    KonvaViewerPictogram,
    entityValidationflows,
  },

  watch: {

    // al marcar 'señalar en plano' poner el emplazamiento por defecto del proyecto si se encuentra
    setOnDrawing: function() {
      if (this.setOnDrawing) {
        let loc = this.locationsList.filter( location => location.reference_code.toLowerCase() == 'project_location' )
        if (loc.length) {
          this.form.location_id = loc[0].id
        }
      }
    },

    'formFields': {
      handler(newVal, oldVal) {
        let code2 = '';

        newVal.forEach((formField, index) => {
          // Verifica si el campo tiene un código asignado
          if (formField.code) {
            const matchedValue = this.issuefields[index].values.find(value => value.code === formField.code);
            if (matchedValue) {
              code2 += `${matchedValue.code}-`;
            }
          }
        });
        code2 = code2.slice(0, -1);
        this.form.code2 = code2;

        if (this.company.alias === 'tkelevator' && this.form.code2) {
          this.form.code2 = this.code2AddTkelevator(this.form.code2);
        }

      },
      deep: true,
    },

    'formCustomfields': {
      deep: true,
      handler(newVal) {
        this.form.customfields = newVal.map(field => {
          /// si fiel_type es 3 el valor es un booleano y debemos pasarlo a 1 o 0
          const isCheckbox = field.field_type == 3
          return {
            customfield_id: field.customfield_id,
            value_free: isCheckbox ? (field.value_free ? 1 : 0) : field.value_free,
            value_id: field.value_id,
          }
        })
      }
    },

    'form.type_id': function(newVal, oldVal) {
    // console.log('Nuevo valor seleccionado:', newVal);

      if (!newVal) {
        this.customfields = []
        this.formCustomfields = []
        this.form.customfields = []
        this.withFlow = false
        this.blockFields = false
        this.isSupply = false
        this.issueTypeSupply = []
        this.form.supply_id = null
        this.isTypeSupplyProvider = false
        this.issueTypeSupplyProviderList = []
        this.form.supply_provider_id = null
        this.scheduleAdvancedTypeParticipantsSync()
        return
      }

      const typeId = Number(newVal)

      let selectedType = this.issueTypesList.find(t => t.id == typeId)

      if (!selectedType) {
        const parent = this.issueTypesList.find(
          t => Array.isArray(t.children) && t.children.some(child => child.id === typeId)
        )
        if (parent) {
          selectedType = parent
          this.form.type_id = parent.id
          this.form.supply_id = typeId
        }
      }

      // verificamos si el tipo tiene customfields
      if (selectedType && selectedType.customfields) {
        this.customfields = selectedType.customfields
        
        this.formCustomfields = this.customfields.map(field => new Form({
          customfield_id: field.id,
          customfield_name: field.name,
          field_type: field.field_type,
          value_free: null,
          value_id: null,
        }));

      } else {
        this.customfields = []
        this.formCustomfields = []
        this.form.customfields = []
      }

      // si el campo with_flow es 1 entonces activamps el withFlow ademas esto solo se aplica si project.issue_template es 1
      if (this.project.issue_template) {
        this.withFlow = selectedType && selectedType.with_flow == 1
        // verificamos si el tipo seleccionado tiene el bloqueo de campos activo
        this.blockFields = selectedType && selectedType.block_fields == 1
        
        // Verificar si estamos escalando de un tipo normal a uno escalado
        let isScalingFromNormal = false
        if (this.originalTypeId && selectedType && !this.createNew) {
          let originalType = this.issueTypesList.find(t => t.id === Number(this.originalTypeId))
          
          // Si no encontramos el tipo original, buscar en los children que seria de tipo supply
          if (!originalType) {
            const parentWithChild = this.issueTypesList.find(
              t => Array.isArray(t.children) && t.children.some(child => child.id === Number(this.originalTypeId))
            )
            if (parentWithChild) {
              originalType = parentWithChild.children.find(child => child.id === Number(this.originalTypeId))
            }
          }
          
          if (originalType) {
            // Si el tipo original era normal (is_scaled == 0 o no existe) y el nuevo es escalado (is_scaled == 1)
            const originalIsNormal = !originalType.is_scaled || originalType.is_scaled == 0
            const newIsScaled = selectedType.is_scaled == 1
            isScalingFromNormal = originalIsNormal && newIsScaled
          }
        }
        
        if (this.blockFields && !isScalingFromNormal) {
          // seleccionamos emplazamiento por defecto
          // this.form.location_id = this.locationsList[1]?.id
          // nullificamos los campos bloqueados solo si NO estamos escalando de normal a escalado
          // this.form.class_id = null
          // si en un futuro se quieren conservar los valores originales, se puede hacer de la siguiente manera:
          // podemos usar el originalTypeId y originalSupplyId para restaurar los valores originales
          this.form.supply_id = null
          this.form.supply_provider_id = null
          this.form.discipline_id = null
          this.form.origin_id = null
          this.form.steps_to_implement = null
          this.form.steps_implemented = null
        } else if (this.blockFields && isScalingFromNormal) {
          // Si estamos escalando de normal a escalado, restaurar los valores originales
          // Los campos seguirán bloqueados pero mantendrán sus valores originales
          this.form.supply_id = this.originalSupplyId
          this.form.supply_provider_id = this.originalSupplyProviderId
          this.form.discipline_id = this.originalDisciplineId
          this.form.origin_id = this.originalOriginId
          this.form.steps_to_implement = this.originalStepsToImplement
          this.form.steps_implemented = this.originalStepsImplemented
        }

        // si es un tipo que escala a no conformidad
        if (selectedType && selectedType.is_scaled == 1) {
          this.form.scaled_to_nc = 1
        } else {
          this.form.scaled_to_nc = null
        }
      }

      this.isSupply = selectedType && selectedType.type === 'supply'

      if (this.isSupply) {
        this.issueTypeSupply = selectedType.children || []
      } else {
        this.issueTypeSupply = []
        this.form.supply_id = null
        this.issueTypeSupplyProviderList = []
        this.form.supply_provider_id = null
      }

      this.scheduleAdvancedTypeParticipantsSync()
    },

    'form.supply_id': function(newVal, oldVal) {
      // console.log('Nuevo valor seleccionado:', newVal);
      // estraemos la data de issue_types_list
      if (newVal == null) {
        this.isTypeSupplyProvider = false
        this.issueTypeSupplyProviderList = []
        this.scheduleAdvancedTypeParticipantsSync()
        return
      }
      this.isTypeSupplyProvider = true
      let selectedType = this.issueTypeSupply.find(type => type.id == newVal);
      if (selectedType) {
        this.issueTypeSupplyProviderList = selectedType.providers;
        // Si ya hay un proveedor seleccionado, verifica que esté en la lista
        if (this.form.supply_provider_id) {
          const providerExists = this.issueTypeSupplyProviderList.some(
            provider => provider.id === this.form.supply_provider_id
          );
          if (!providerExists) {
            this.form.supply_provider_id = null; // Resetea si no existe
          }
        }
      }

      this.scheduleAdvancedTypeParticipantsSync()
    },

    'form.is_open': function(newVal, oldVal) {
      // verificamos si hay tareas pendientes en la incidencia 
      if (!this.createNew && this.issueTasks.length) {
        if (newVal == false && oldVal == true) {
          let pendingTasks = this.issueTasks.filter( task => task.status != 1 )
          if (pendingTasks.length) {
            this.$buefy.toast.open({
              message: this.$t('issue_cant_close_with_pending_tasks'),
              type: 'is-danger',
              position: 'is-top-right',
              duration: 5000
            })
            this.$nextTick(() => {
              this.form.is_open = true
            })
            return
          }

        }
      }
      
      if (!newVal) {
        if (this.closedDate == null) {
          this.form.end_date = this.getNow()
          this.closedDate = new Date()
        }
      } else {
        this.form.end_date = null
        this.closedDate = null
      }
    },

    // si se asigna un clodDate, se cierra la incidencia
    closedDate: function(newVal, oldVal) {
      if (newVal) {
        if (this.loadCloseDate){
          this.form.is_open = false
        } else {
          this.loadCloseDate = true
        }
        
      }
    },

    'form.location_id': function(newVal, oldVal) {

      if (newVal == 0) {
        this.showMap = true

        if (navigator.geolocation) {

          // navegador pide permiso ubicacion
          navigator.geolocation.getCurrentPosition((position) => {

            // para el post new location
            this.newLocation.latitude = position.coords.latitude
            this.newLocation.longitude = position.coords.longitude
            // para recargar el mapa con el marker en esta position
            this.userLocation.push({
              id: 1,
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              draggable: true, // inicialmente se muestra ubicacion usuario pero se permite mover
            });
            EventBus.$emit("load-locations", this.userLocation);

          });
        }

      } else {
        this.showMap = false
      }
    },

    'form.template_id': function(newVal, oldVal) {
      if (newVal) {
        let selectedTemplate = this.templates.find( template => template.id == newVal )
        this.form.flow_description = selectedTemplate.description
      }

    },

  },

  data: () => ({
    createNew: false,
    activityId: null,
    subactivityId: null,
    isSupply: false,
    issueId: null,
    processingData: false,
    processingMessage: '',
    form: new Form({
      name: '',
      class_id: null,
      type_id: '',
      supply_provider_id: null,
      discipline_id: null,
      supply_id : null, // subtipo de type_id. Realmente guardaremos en type_id el id de este subtipo.
      origin_id: null,
      location_id: '',
      is_open: true,
      start_date: null,
      end_date: null,
      description: '',
      manager_user: null,
      activity_id: null,
      document_id: null, // si elige marcar incidencia en plano, id documento y coordenadas click
      // document_page: 0,  Obsoleto, de cuando solo habia un marker. Estos 3 irán dentro del array markers
      // document_x: 0,
      // document_y: 0,
      markers: [], // array de markers en plano
      estimated_resolution_date: null,
      steps_to_implement: null,
      steps_implemented: null,
      scaled_to_nc: null,
      code2: null,
      customfields: [],
    }),
    customfields: [],
    formCustomfieldsw: new Form({
      name: '',
      value: '',
    }),
    formCustomfields: [],
    customfieldTypes: [
      'select',
      'input',
      'calendar',
      'checkbox',
    ],
    issueTasks: [],
    issuefields: [],
    formFields: [],
    blockFields: false,
    withFlow: false,
    templates: [],
    type_id: null, // solo se carga si se esta editando una incidencia y el tipo seleccionado se escala a no conformidad
    startDate: null,
    closedDate: null,
    loadCloseDate: false,
    locationsList: [],
    issueClassesList: [],
    issueTypesList: [],
    issueTypeSupplyProviderList: [],
    isTypeSupplyProvider: false,
    issueTypeSupply:[],
    issueDisciplinesList: [],
    issueOriginsList: [],
    setOnDrawing: false, // indica si la incidencia será marcada sobre el plano
    setOnPictogram: false, // indica si la incidencia será marcada sobre el pictograma
    markerIsSet: false, // flag que indica si ya se señaló una ubicación en el plano
    drawings: [], // documentos (planos) vinculados a actividad padre, donde ubicar la incidencia
    drawing: null, // posible futuro plano seleccionado donde clicar para crear incidencia (objeto pdfjsLib)
    drawingDocument: null, // posible futuro plano seleccionado (objeto document normal)
    scale: 1, // scale of selected drawing (zoom)
    showMap: false, // para indicar emplazamiento personalizado distinto de los emplazamientos de proyecto
    userLocation: [], // ubicacion del usuario para centrar el mapa
    apiUrl: '/api/v2/issue',
    newLocation: new Form({
      reference_code: '',
      name: '',
      latitude: '',
      longitude: '',
      is_virtual: 1,
    }),
    editorOption: {
      placeholder: "",
      modules: {
        toolbar: {
          container: [
            ["emoji"],
            ["bold", "italic", "underline", "strike"],
            [{list: "ordered"}, {list: "bullet"}],
            ["link", "clean"]
          ],
          handlers: {
            emoji: function () {
            }
          }
        },
        "emoji-toolbar": true,
        "emoji-textarea": false,
        "emoji-shortname": true,
        mention: {
          offsetTop: 2,
          allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
          mentionDenotationChars: ["@", "#"],
          source: function (searchTerm, renderList, mentionChar) {
            let values;
            let i = 0;
            let self = this;
            if (mentionChar === "@") {
              values = at.state.atUsers;
            }

            if (searchTerm.length === 0) {
              renderList(values, searchTerm);
            } else {
              const matches = [];
              if (values) {
                for (i = 0; i < values.length; i++) {
                  if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) matches.push(values[i]);
                }
              }
              renderList(matches, searchTerm);
            }
          }
        }
      },
      formats: [
        'mention',
        'background',
        'bold',
        'color',
        'font',
        'code',
        'italic',
        'link',
        'size',
        'strike',
        'script',
        'underline',
        'blockquote',
        'header',
        'indent',
        'list',
        'align',
        'direction',
        'code-block',
        'formula'
        // 'image'
        // 'video'
      ]
    },


    // para trabajar los pictogramas
    pictogram: null,
    workLayer: null, // // capa donde  trabajará el usuario, solo permite trabajar en esa capa si null trabaja en todas
    activityId: null,
    subactivityId: null,
    typeRegister: 'issue',
    canActionsPictogram: {
      'save': false,
      'select_entity': true,
      'showButtonInfo': false,
      'showButtonReturn': false,
      'showButtonCompletion': false
    },
    assignment: null,
    AssignmentLineId: null,
    lockTypeMap : {
      22: 'task_issue_without_blocking',
      23: 'task_issue_with_task_blocking',
      24: 'task_issue_with_activity_blocking',
      28: 'task_issue_with_parent_activity_blocking',
      25: 'task_issue_with_project_blocking',
    },
    originalCollaborators: [],
    originalParticipants: [],
    typeParticipantIds: [],
    // Valores originales antes de editar (para preservar al escalar de normal a escalado)
    originalTypeId: null,
    originalSupplyId: null,
    originalSupplyProviderId: null,
    originalDisciplineId: null,
    originalOriginId: null,
    originalStepsToImplement: null,
    originalStepsImplemented: null,
    // Archivos pendientes de subir (para creación de incidencia)
    pendingFiles: [],
    isUploadingFiles: false,
    uploadPercentage: 0,
    uppy: null,
    uppyKeyFileUploadCurrent: null,
  }),

  computed: {
    ...mapGetters({
      user: 'auth/userBasicInfo',
      project: 'app/project',
      company: 'app/company',
    }),
  },

  created () {
    // Parámetros en la ruta
    this.activityId = this.$route.params.activity_id
    this.subactivityId = this.$route.params.subactivity_id
    this.issueId = this.$route.params.issue_id
    // Crear nueva o editar
    this.createNew = (this.$route.name === 'issue.create') || (this.$route.name === 'subissue.create')
    if (this.createNew) {
      let activityId = this.subactivityId ? this.subactivityId : this.activityId

      // El responsable es el mismo de la actividad
      this.getActivityManagerUser(activityId)
      this.getActivityTags(activityId) //por defecto tags de la actividad
      this.getActivitySelectableDocuments(activityId) // listado de planos vinculados con la actividad
      this.form.activity_id = activityId
      this.form.start_date = this.getNow()
      this.startDate = new Date()
      this.$options.title = 'issue_create_page_title'
      if (this.$route.params.assignmentId) {
        this.AssignmentLineId = this.$route.params.lineId
        this.getAssignment(this.$route.params.assignmentId)
      }
    } else {
      this.$options.title = 'issue_edit_page_title'
    }
    this.$options.subtitle = ['subactivity_create_page_subtitle', [this.$route.params.activityName]]
  },

  mounted () {
    // Lista con las localizaciones del proyecto
    this.getLocationsList()
    this.getIssueTypesList()
    this.getTemplates()
    this.getDataPictogram()  // method get data pictogram
    this.getIssuefields()
    
    if (this.createNew) {
      // El creador de la incidencia
      this.$refs.creator.usersList.unshift(this.user)
      // si project.issue_template y ademas project.can_collaborate
      // se añade al creador como colaborador
      if (this.project.issue_template) {
        if (this.project.can_collaborate) {
          this.$refs.collaborators.usersList.unshift(this.user)
        }
      }
    } else {
      // Editar
      this.getIssueData()
      this.getIssueTasks()
      // Refrescamos las listas de usuarios
      this.$nextTick(() => {
        if (this.$refs.manager) this.$refs.manager.refreshData()
        if (this.$refs.creator) this.$refs.creator.refreshData()
        if (this.$refs.participants) this.$refs.participants.refreshData()
        if (this.$refs.collaborators) this.$refs.collaborators.refreshData()
        if (this.$refs.issue_admin) this.$refs.issue_admin.refreshData()
        if (this.$refs.issue_resolutors) this.$refs.issue_resolutors.refreshData() 
      })
    }

    if (this.$refs.issueName) {
      this.$refs.issueName.setFocus()
    }

    // Inicializar Uppy para subida de archivos a S3
    this.uppy = new Uppy({
      debug: process.env.NODE_ENV === 'development',
      autoProceed: false,
      allowMultipleUploadBatches: false,
    })
    .use(AwsS3, {
      shouldUseMultipart: true,
      limit: 3,
      companionUrl: '/api/v2/',
      endpoint: '/api/v2/',
      headers: {
        'Authorization': 'Bearer ' + store.getters['auth/token']
      }
    })
    .on('upload-progress', (file, progress) => {
      this.uploadPercentage = parseInt(
        Math.round((progress.bytesUploaded * 100) / progress.bytesTotal)
      )
    })
  },

  methods: {
    async getLocationsList() {
      const { data } = await axios.get('/api/v2/locations', {params: { 'p': this.project.id, 'all': true }})
      if (data && data.success) {
        this.locationsList = data.locations
        this.locationsList.unshift({ id: 0, name: 'Señalar en el mapa', reference_code: 'custom place' })
      } else {
        this.$notify.error('error_loading_locations')
      }
    },

    async getIssueTypesList() {
      const { data } = await axios.get('/api/v2/company/' + this.company.id + '/issue-classes-types-disciplines-origins', {params: {project_id: this.project.id}})
      if (data && data.success) {
        this.issueClassesList = data.classes
        this.issueTypesList = data.types
        this.issueDisciplinesList = data.disciplines
        this.issueOriginsList = data.origins
      } else {
        this.$notify.error('Error cargando tipos / disciplinas / origenes')
      }
    },

    async getAssignment(assignmentId) {
      const { data } = await axios.get('/api/v2/assignment/' + assignmentId)
      if (data && data.success) {
        this.assignment = data.assignment
      } else {
        this.$notify.error('error_loading_assignment')
      }
    },



    async getActivityManagerUser(activityId) {
      let url = '/api/v2/activity/' + activityId + '/users'
      const { data } = await axios.get(url, {params: {p: 'admin', r: 'activity_admin'}})
      if (data && data.success) {
        // Añado el responsable de la actividad como responsable de la incidencia
        this.$refs.manager.usersList = data.users_list

        // Solo tras cargar manager, cargamos resto participantes (evita errores por asincronia)
        this.getProjectIssueUsers(this.project.id)
        this.getProjectIssueAdminUsers(this.project.id)
        this.getProjectIssueResolutorUsers(this.project.id)

      } else {
        this.$notify.error('error_getting_manager_user')
      }
    },

    // Carga participantes definidos como usuarios de incidencia en el proyecto
    async getProjectIssueUsers(projectId) {
      // Incidencias avanzadas: no cargar issue_user del proyecto; el creador y los del tipo se gestionan aparte
      if (this.project.issue_template == 1) {
        this.copyCreatorToParticipant()
        return
      }

      let url = '/api/v2/project/' + projectId + '/users'
      const { data } = await axios.get(url, {params: {r: 'issue_user'}})
      if (data && data.success) {

        let managerId = this.$refs.manager.usersList[0].user_id
        let creatorId = this.$refs.creator.usersList[0].user_id

        // Añadimos a los usuarios de incidencia del proyecto como participantes (si no es manager ni creador)
        this.$refs.participants.setUsersList(data.users_list.filter(
          (user) => (user.user_id != managerId && user.user_id != creatorId)
        ))

      } else {
        console.log("No issue users in project " + projectId) // solo advertimos por consola. Sin ser visible al user
        // this.$notify.error('error_getting_manager_user') Silencio el error. Si proyecto no tiene 'issue users', devuelve success:false, y parece error sin serlo
      }

      // Finalmente añadir al creador como participante (si no era ya manager)
      this.copyCreatorToParticipant()
    },
    // cargamos issue_admin 
    async getProjectIssueAdminUsers(projectId) {
      let url = '/api/v2/project/' + projectId + '/users'
      const { data } = await axios.get(url, {params: {r: 'issue_admin'}})
      if (data && data.success) {
        this.$refs.issue_admin.usersList = data.users_list
      } else {
        console.log("No issue admins in project " + projectId) // solo advertimos por consola. Sin ser visible al user
      }
      
    },
    
    // get issuefields
    async getIssuefields() {
      const { data } = await axios.get('/api/v2/company/' + this.company.id + '/issuefields')
      if (data && data.success) {
        this.issuefields = data.issuefields
        this.formFields = this.issuefields.map((field) => {
          const form = new Form({
            name: '',
            code: '',
          });
          if (field.load_projects && field.values && field.values.length) {
            const matchedValue = field.values.find(value => value.project_id === this.project.id)
            if (matchedValue) {
              form.name = matchedValue.name
              form.code = matchedValue.code
            }
          }

          return form
        })
      } else {
        this.$notify.error('error_loading_issue_fields')
      }
    },

    async getIssueTasks() {
      const { data } = await axios.get('/api/v2/issue/' + this.issueId + '/issue-tasks')
      if (data && data.success) {
        this.issueTasks = data.issueTasks
      } else {
        this.$notify.error('error_loading_issue_tasks')
      }
    },
    
    // obtenemos los user issue_resolutor
    async getProjectIssueResolutorUsers(projectId) {
      let url = '/api/v2/project/' + projectId + '/users'
      const { data } = await axios.get(url, {params: {r: 'issue_resolutor'}})
      if (data && data.success) {
        const userList = data.users_list
        // si es project.issue_template y ademas project.can_issue_resolutor 
        // se añade al manager como resolutor de incidencia y como colaborador
        const creatorId = this.$refs.creator.usersList[0].user_id
        if (this.project.issue_template) {
          if (this.project.can_issue_resolutor) {
            // this.$refs.issue_resolutors.usersList = userList.filter((user) => user.user_id == creatorId)
            // añadimos al creador como colaborador
            this.$refs.collaborators.usersList = userList.filter((user) => user.user_id == creatorId)
          }
        }
      }
    },

    async getActivityTags(activityId) {
      const { data } = await axios.get('/api/v2/activity/'+activityId+'/tags')
      if (data && data.success) {
        this.$refs.model_tags.initTags(data.tags)
      }
    },

    async getActivitySelectableDocuments(activityId) {
      const { data } = await axios.get('/api/v2/activity/' + activityId + '/selectable-documents')
      if (data && data.success) {
        // de los documentos vinculados, solo los de tipo 'planos'
        this.drawings = data.documents.filter((doc) => doc.project_document_is_drawing == 1)
      } else {
        this.$notify.error('error_loading_documents')
      }
    },

    // añade el creador como participante (en caso de no ser manager)
    copyCreatorToParticipant() {
      if (!this.$refs.participants || !this.$refs.creator?.usersList.length || !this.$refs.manager?.usersList.length) {
        return
      }

      const creatorId = Number(this.$refs.creator.usersList[0].user_id)
      const managerId = Number(this.$refs.manager.usersList[0].user_id)
      const participants = this.$refs.participants

      if (creatorId === managerId) {
        return
      }
      if (participants.usersList.some(user => Number(user.user_id) === creatorId)) {
        return
      }

      if (!this.project.issue_template) {
        participants.__addUserToList(this.user)
      } else if (this.project.can_issue_admin) {
        participants.__addUserToList(this.user)
      }
    },

    scheduleAdvancedTypeParticipantsSync() {
      if (!this.project.issue_template || !this.createNew) {
        return
      }
      this.$nextTick(() => this.syncAdvancedIssueTypeParticipants())
    },

    getEffectiveIssueTypeId() {
      if (this.form.supply_id) {
        return Number(this.form.supply_id)
      }
      if (this.form.type_id) {
        return Number(this.form.type_id)
      }
      return null
    },

    clearAutoTypeParticipants() {
      const participants = this.$refs.participants
      if (!participants || !this.typeParticipantIds.length) {
        this.typeParticipantIds = []
        return
      }

      const autoIds = new Set(this.typeParticipantIds.map(id => Number(id)))
      const remaining = participants.usersList.filter(
        user => !autoIds.has(Number(user.user_id))
      )
      participants.setUsersList(remaining)
      this.typeParticipantIds = []
    },

    async syncAdvancedIssueTypeParticipants() {
      if (!this.project.issue_template || !this.createNew || !this.$refs.participants) {
        return
      }

      const participants = this.$refs.participants

      // Solo quitamos los participantes que venían del tipo anterior (no el creador ni otros manuales)
      this.clearAutoTypeParticipants()

      // Mantener la autoasignación existente del creador
      this.copyCreatorToParticipant()

      const typeId = this.getEffectiveIssueTypeId()
      if (!typeId || (this.isSupply && !this.form.supply_id)) {
        return
      }

      let usersList = []
      let useProjectIssueUsers = false

      try {
        const { data } = await axios.get('/api/v2/issue-type/' + typeId + '/users', {
          params: { p: this.project.id },
        })
        usersList = data?.users_list || []
        useProjectIssueUsers = !!data?.use_project_issue_users
      } catch (error) {
        console.error('Error loading issue type participants', error)
        return
      }

      // Si el tipo no tiene participantes propios y usa usuarios de incidencia del proyecto
      // (los mismos de project-edit con rol issue_user), cargarlos de ahí.
      if (!usersList.length && useProjectIssueUsers) {
        try {
          const { data } = await axios.get('/api/v2/project/' + this.project.id + '/users', {
            params: { r: 'issue_user' },
          })
          usersList = data?.users_list || []
        } catch (error) {
          console.error('Error loading project issue users', error)
          return
        }
      }

      if (!usersList.length) {
        return
      }

      const managerId = this.$refs.manager?.usersList[0]?.user_id
      const addedIds = []

      usersList.forEach((rawUser) => {
        const user = {
          user_id: rawUser.user_id || rawUser.id,
          fullname: rawUser.fullname,
          email: rawUser.email,
          avatar: rawUser.avatar,
          phone: rawUser.phone || '',
          area: rawUser.area || '',
        }

        if (!user.user_id) {
          return
        }
        if (managerId && Number(user.user_id) === Number(managerId)) {
          return
        }
        if (participants.usersList.some(u => Number(u.user_id) === Number(user.user_id))) {
          return
        }

        participants.__addUserToList(user)
        addedIds.push(user.user_id)
      })

      this.typeParticipantIds = addedIds
    },

    async getIssueData() {
      const { data } = await axios.get('/api/v2/issue/' + this.issueId)
      if (data) {

        this.form.name = data.data.name
        this.form.description = data.data.description
        this.form.location_id = data.data.location_id
        this.form.class_id = data.data.class_id

        const rawTypeId = Number(data.data.type_id)
        let parentType = this.issueTypesList.find(t => t.id === rawTypeId)
        let typeId = rawTypeId
        let supplyId = data.data.supply_id != null ? Number(data.data.supply_id) : null

        if (!parentType) {
          parentType = this.issueTypesList.find(
            t => Array.isArray(t.children) && t.children.some(c => c.id === rawTypeId)
          )

          if (parentType) {
            typeId = parentType.id
            if (!supplyId) supplyId = rawTypeId
          }
        }

        this.form.type_id = typeId
        this.type_id = typeId
        this.form.scaled_to_nc = data.data.scaled_to_nc
        this.form.supply_id = supplyId

        // Guardar valores originales antes de editar
        this.originalTypeId = typeId
        this.originalSupplyId = supplyId
        this.originalSupplyProviderId = data.data.supply_provider_id
        this.originalDisciplineId = data.data.discipline_id
        this.originalOriginId = data.data.origin_id
        this.originalStepsToImplement = data.data.steps_to_implement
        this.originalStepsImplemented = data.data.steps_implemented

        if (this.form.supply_id) {
          const selectedType = this.issueTypeSupply.find(type => type.id == this.form.supply_id);
          if (selectedType) {
            this.issueTypeSupplyProviderList = selectedType.providers;
          }
        }

        this.form.supply_provider_id = data.data.supply_provider_id;

        this.form.discipline_id = data.data.discipline_id
        this.form.origin_id = data.data.origin_id
        this.form.is_open = data.data.is_open == 1
        this.form.start_date = this.formatDate(data.data.created_at)
        this.startDate = new Date(data.data.created_at)
        this.form.end_date = data.data.closed_at != null ? this.formatDate(data.data.closed_at) : null
        this.closedDate = data.data.closed_at? new Date(data.data.closed_at) : null
        this.form.estimated_resolution_date = data.data.estimated_resolution_date ? new Date(data.data.estimated_resolution_date) : null
        this.form.steps_to_implement = data.data.steps_to_implement
        this.form.steps_implemented = data.data.steps_implemented

        this.getCreatorUser(data.data.creator_id)
        this.getManagerUser()
        this.$refs.model_tags.initTags(data.data.tags)

        if (this.closedDate == null) {
          this.loadCloseDate = true
        }

        // Espera a que las listas de usuarios estén actualizadas
        await this.$refs.participants.refreshData();
        await this.$refs.collaborators.refreshData();

        this.originalParticipants = this.$refs.participants.getUsersIds().slice();
        this.originalCollaborators = this.$refs.collaborators.getUsersIds().slice();

      } else {
        this.$notify.error('error_loading_issue_data')
      }
    },


    async getCreatorUser(creatorId) {
      const { data } = await axios.get('/api/v2/user/' + creatorId + '?basic=1')
      if (data && data.success) {
        this.$refs.creator.usersList.unshift(data.user)
      }
    },

    async getManagerUser() {
      let url = '/api/v2/issue/' + this.issueId + '/users'
      const { data } = await axios.get(url, {params: {p: 'admin', r: 'activity_admin'}})
      if (data && data.success) {
        this.$refs.manager.usersList = data.users_list
      }
    },

    async getTemplates(){
      this.isLoadingTemplates = true
      const { data } = await axios.get("/api/v2/project/"+this.project.id+"/validations-templates", {params: {type: 2}});
      this.templates = data.templates;
    },

    async sendIssueData() {
      if (this.withFlow && !this.form.template_id) {
        if(this.createNew){
          this.$notify.error('select_v_flow')
          return
        }
      }

      this.processingData = true
      this.processingMessage = this.$t(this.createNew ? 'creating_issue_please_wait' : 'saving_issue_please_wait')


      // Validación del campo name solo cuando se está creando una nueva incidencia
      if (this.createNew && (! this.form.name || this.form.location_id === '')) {
        this.$notify.error('insert_title_and_location');
        this.processingData = false;
        return;
      }

        // Detecta los nuevos participantes y colaboradores
      const currentParticipants = this.$refs.participants.getUsersIds();
      const currentCollaborators = this.$refs.collaborators.getUsersIds();

      const newParticipants = currentParticipants.filter(
        id => !this.originalParticipants.includes(id)
      );
      const newCollaborators = currentCollaborators.filter(
        id => !this.originalCollaborators.includes(id)
      );

      const allParticipantEmails = this.$refs.participants.getUserEmails();
      const participantEmails = currentParticipants
        .map((id, idx) => newParticipants.includes(id) ? allParticipantEmails[idx] : null)
        .filter(email => email);

      const allCollaboratorEmails = this.$refs.collaborators.getUserEmails();
      const collaboratorEmails = currentCollaborators
        .map((id, idx) => newCollaborators.includes(id) ? allCollaboratorEmails[idx] : null)
        .filter(email => email);

      // Añadimos responsable, participantes y colaboradores
      this.form.manager_user = this.$refs.manager.usersList.length > 0 ? this.$refs.manager.usersList[0].user_id : null
      
      this.form.participants = currentParticipants;
      this.form.participant_emails = participantEmails;
      this.form.send_email_participants = newParticipants.length > 0;
      this.form.collaborators = currentCollaborators;
      this.form.collaborator_emails = collaboratorEmails;
      this.form.send_email_collaborators = newCollaborators.length > 0;
      


      // verificamos si end_date es null y ademas si se esta cerrando la incidencia
      if (this.form.end_date == null && !this.form.is_open) {
        // asignamos la fecha actual 
        this.form.end_date = this.getNow()
      }

      if (this.assignment) {
        this.form.assignable_type = 'assignment'
        this.form.assignable_id = this.AssignmentLineId
      }

      // solo para proyectos con plantilla de incidencias avanzadas
      if ( this.project.issue_template ) {
        this.form.issue_admin = this.$refs.issue_admin.getUsersIds();
        this.form.issue_resolutors = this.$refs.issue_resolutors.getUsersIds();
      }
      
      if (this.form.estimated_resolution_date instanceof Date) {
        // this.form.estimated_resolution_date = this.form.estimated_resolution_date?.toISOString().substring(0,10) // timezone issues (-1 day)
        this.form.estimated_resolution_date = format(this.form.estimated_resolution_date, 'yyyy-MM-dd')
      }

      // Edit
      var url = this.apiUrl
      if (! this.createNew) {
        url += '/' + this.issueId
      }

      // Al crear nuevo y seleccionar ubicacion en mapa, crear primero la ubicacion virtual
      if (this.createNew && this.form.location_id == 0) {
        //crear location virtual y entonces con el id de la location virtual crear la incidencia
        let location = await this.addLocation()
        
        if (location) {
          this.form.location_id = location.id
        } else {
          this.processingData = false
          return
        }
      }

      // Si elige señalar en plano y no seleccionó fichero
      if (this.setOnDrawing && this.form.document_id == null) {
        this.$notify.error('select_drawing_and_set_issue')
        this.processingData = false
        return
      }
      // se asegura de resetear document_id si setOnDrawing esta desmarcado (para no vincular issue con document en backend)
      if (! this.setOnDrawing) {
        this.form.document_id = null
      }

      if(this.form.supply_id != null) {
        // realmente guardamos en type_id el id del subtipo (supply_id)
        this.form.type_id = this.form.supply_id
      }

      if (this.setOnPictogram) {
        let entitiesWithIssue = this.$refs.refViewerPictogram.GetModifiedEntities()

        if (entitiesWithIssue.length === 0) {
          this.$notify.error('select_pictogram_and_set_issue')
          this.processingData = false
          return
        }
        else {
          this.form.pictogram_id = this.pictogram.id
          let arrType = entitiesWithIssue.map( (item) => item.type )
          this.form.pictogram_entity_type = arrType.filter((item, index) => arrType.indexOf(item) === index).join(';')
          this.form.pictogram_entities_with_issue = JSON.stringify(entitiesWithIssue)
        }
      }
      // Enviamos el form
      try {
        const { data } = await this.form.post(url)
        if (data && data.success) {

          const wasCreateNew = this.createNew
          const issue_id = wasCreateNew ? data.issue_id : this.issueId

          // solo si withFlow, generamos validacion
          if (this.withFlow && this.form.template_id) {
            const validationUrl = '/api/v2/validations/generate';
            const validationData = {
              company_id: this.company.id,
              config_tasks: false,
              description: this.form.flow_description,
              entity_id: issue_id,
              entity_type: 'issue',
              folder_id: null,
              tasks: [],
              techspec_id: null,
              template: this.form.template_id
            }

            await axios.post(validationUrl, validationData)
          }

          if (wasCreateNew) {
            // Subir archivos pendientes si los hay
            if (this.pendingFiles.length) {
              this.processingMessage = this.$t('uploading_files') + '...'
              await this.uploadPendingFiles(issue_id)
            }
            this.processingData = false
            this.$notify.success('success_creating_issue')
            const homePath = `/activity/${this.activityId}${this.subactivityId ? `/subactivity/${this.subactivityId}` : ''}/issue/${issue_id}`
            this.$router.push(homePath)
          } else {
            this.processingData = false
            this.$notify.success('success_editing_issue')
            this.$router.go(-1)
          }


        } else {
          this.processingData = false
          this.$notify.error(this.createNew ? 'error_creating_issue' : 'error_editing_issue')
        }
      } catch (error) {
        this.$notify.error(this.createNew ? 'error_creating_issue' : 'error_editing_issue')
        this.processingData = false
      }
    },

    getNow() {
      return this.formatDate(new Date())
    },

    formatDate(date) {
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' }
      let _date = new Date(date)
      return _date.toLocaleDateString('es-ES', options)
    },

    updateDate(newDate) {
      // Al seleccionar una fecha nueva, actualiza `form.start_date` con el formato `dd/mm/yyyy`
      this.form.start_date = this.formatDate(newDate)
    },
    updateCloseDate(newDate) {
      // Al seleccionar una fecha nueva, actualiza `form.end_date` con el formato `dd/mm/yyyy`
      this.form.end_date = this.formatDate(newDate)
    },


    // carga la primera pagina del pdf en un etiqueta html canvas donde permita clicar la ubicacion de la incidencia
    async loadDrawing(drawing, scale=1) {

      this.form.document_id = drawing.document_id // para enviar a backend
      this.drawingDocument = drawing // guardamos para saber cual se seleccionó
      this.markerIsSet = false // documento recien cargado en canvas, no hay marker seleccionado

      PdfCanvas.setAssetUrl(this.assetVapor(''))

      // nivel de zoom. Nunca menos de 0.4 ni mas de 2.6
      if (scale < 0.4) {
        scale = 0.4
      }
      if (scale > 2.6) {
        scale = 2.6
      }
      this.scale = scale.toFixed(2)

      this.drawing = await PdfCanvas.loadDocument(drawing, {scale: this.scale})

    },

    // dibuja un marker en la parte clickada sobre el plano
    async setMarker(event) {

      // if (this.markerIsSet) { Obsoleto. Es de cuando solo habia un marker

      //   // Si ya habia un marker, resetea el dibujo para establecer el marker en el nuevo sitio clicado
      //   this.drawing = await PdfCanvas.loadDocument(this.drawingDocument)
      //   this.markerIsSet = false

      // }

      if (this.drawing) {

        this.markerIsSet = true

        this.drawing.getPage(1).then(page => {

          let rect = event.target.getBoundingClientRect();
          let x = event.clientX - rect.left; // x position within the element.
          let y = event.clientY - rect.top;  // y position within the element.

          let canvas = document.getElementById('canvas')
          let context = canvas.getContext('2d')

          const img = new Image();
          img.onload = () => {
            context.drawImage(img, x-PdfCanvas.markerImg.width, y-PdfCanvas.markerImg.height);
          };
          img.src = this.asset(PdfCanvas.markerImg.src);

          // para enviar a backend y guardar en metadata. Como valor de x,y depende de nivel de zoom, guardaremos porcentaje
          this.form.markers.push({
            document_page: 0,
            document_x: parseFloat( (x * 100) / canvas.width ).toFixed(4),
            document_y: parseFloat( (y * 100) / canvas.height ).toFixed(4)
          })

        })
      }


    },


    // Reset all markers
    async resetMarkers() {
      this.markerIsSet = false
      this.form.markers = []
      // resetea el dibujo
      this.drawing = await PdfCanvas.loadDocument(this.drawingDocument)
    },


    // Para nuevas incidencias, en caso de seleccionar emplazamiento "en el mapa"
    // Crear previamente el emplazamiento con el flag "virtual" y luego crear la incidencia
    async addLocation() {
      let url = '/api/v2/location/' + this.project.id + '/addLocation';

      // referencia: issue + 3 chars/digits aleatorios + 3 digitos aleatorios
      this.newLocation.reference_code = 'issue_' + Math.random().toString(36).substring(2, 5) + '_' + Math.floor(100 + Math.random() * 900);

      // Validaciones
      if (!this.newLocation.latitude || !this.newLocation.longitude) {
        this.$notify.error('Latitude and Longitude are required');
        return null;
      }

      try {
        const { data } = await this.newLocation.post(url);

        if (data.success) {
          return data.data;
        } else {
          this.$notify.error(data.error_msg || 'location_change_fail');
          return null;
        }
      } catch (error) {
        this.$notify.error(data.error_msg || 'location_change_fail')
        return null;
      }
    },


    async updPlace(place) {
      this.newLocation.latitude = place.latitude
      this.newLocation.longitude = place.longitude
    },

    async getDataPictogram() {
      // Submit the form.
      let data = null

      await axios.get('/api/v2/activity/' + (this.subactivityId ? this.subactivityId : this.activityId) + '/pictogram')
        .then(response => (data = response.data))
        .catch(error => console.log(error));

      //const { data } = await this.form.post('api/v2/login')

      if (data && data.success) {
        this.pictogram = data.pictogram
      }
    },

    // Solo para TKELEVATOR y si se ha seleccionado algun valor de issuefields
    // entonces añadimos a ese code2 de partida, el project reference + discipline code + type code
    code2AddTkelevator(code2) {
      const parts = [code2];

      if (this.project && this.project.reference) {
        parts.push(this.project.reference);
      }

      if (this.form.discipline_id) {
        const discipline = this.issueDisciplinesList.find(d => d.id === this.form.discipline_id);
        if (discipline && discipline.code) {
          parts.push(discipline.code);
        }
      }

      if (this.form.type_id) {
        const type = this.issueTypesList.find(t => t.id === this.form.type_id);
        if (type && type.code) {
          parts.push(type.code);
        }
      }

      return parts.filter(p => p).join('-');
    },

    async uploadPendingFiles(issueId) {
      if (!this.pendingFiles.length) return

      this.isUploadingFiles = true
      const uploadEndpoint = '/api/v2/issue/' + issueId + '/document'

      for (let i = 0; i < this.pendingFiles.length; i++) {
        const file = this.pendingFiles[i]
        this.uploadPercentage = 0

        try {
          // Subir a S3 via Uppy
          if (this.uppyKeyFileUploadCurrent) {
            this.uppy.removeFile(this.uppyKeyFileUploadCurrent)
          }
          this.uppyKeyFileUploadCurrent = this.uppy.addFile({
            name: file.name,
            type: file.type,
            data: file,
            source: 'Local',
            isRemote: false,
          })
          const result = await this.uppy.upload()

          if (result.successful.length > 0) {
            const response = result.successful[0].response
            const params = {
              key: response.body.key,
              content_type: file.type,
            }

            let form = new FormData()
            form.append('original_filename', file.name)
            form.append('entity_type', 'issue')
            form.append('entity_id', issueId)
            form.append('project_id', this.project.id)
            form.append('aws_response', JSON.stringify(params))

            await axios.post(uploadEndpoint, form)
          }
        } catch (error) {
          console.error('Error subiendo archivo:', file.name, error)
          this.$notify.error('upload_document_error')
        }
      }

      this.isUploadingFiles = false
      this.uploadPercentage = 0
      this.pendingFiles = []
    },
  },

};
</script>

<style scoped>
/* FIX TEMPORAL. UN PAQUETE (PROBABLEMENTE @BIMDATA/VIEWER) ESTA SOBREESCRIBIENDO LA CLASE .flex-col */
@media (min-width: 1024px) {
  .lg\:flex-row {
    flex-direction: row;
  }
}
@media (min-width: 640px) {
  .sm\:flex-row {
    flex-direction: row;
  }
}

/* Documentos compactos en vista de edición de incidencia */
.issue-documents-compact >>> .entity-document-thumbail {
  max-width: 80px;
  max-height: 80px;
}
.issue-documents-compact >>> .w-1\/5 {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
}
</style>
  